
import {
  Vue, Component,
} from 'vue-property-decorator';
import Editor from '@/components/Editor.vue';
import { Lead, PermissionCode, User } from '@/types';

@Component({
  components: {
    Editor,
  },
})
export default class LeadSharedNotes extends Vue {
  loading = false

  get user(): User {
    return this.$store.getters.currentUser;
  }

  get userPermissions(): PermissionCode[] {
    return this.$store.getters.currentUserPermissions;
  }

  get lead(): Lead {
    return this.$store.getters.currentLead;
  }

  get notes(): string {
    return this.lead?.notes || '';
  }

  get updatedAt(): Date | null {
    return this.lead?.notesUpdatedAt;
  }

  // TODO: Memorizzare anche chi ha modificato le note
  get updatedBy(): null {
    return null;
  }

  hasPermission(codename: PermissionCode): boolean {
    if (!this.user) return false;
    if (this.user.isSuperUser) return true;

    return this.userPermissions.includes(codename);
  }

  async onSave({ content, notify }: { content: string; notify: boolean }) {
    console.log('LeadSharedNotes: onSave()'); // eslint-disable-line no-console

    this.loading = true;

    await this.$store.dispatch('updateLead', {
      updateType: 'sharedNotes',
      update: {
        notes: content,
        notify,
      },
    });

    setTimeout(() => {
      this.loading = false;
    }, 500);
  }
}
